export const generalTabRoute = 'applet-deployment-general';
export const paramsTabRoute = 'applet-deployment-params';
export const sparkplugTabRoute = 'applet-deployment-sparkplug';
export const jsonTabRoute = 'applet-deployment-json';
